/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListBrandsQueryResponse,
  ListBrandsQueryParams,
} from '../types/ListBrands'

function getListBrandsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/brands/` as const,
  }
  return res
}

/**
 * @description Architecture: READ operation - uses pure DRF pattern.
 * Uses DRF's built-in retrieve() method.
 * @summary List brands
 * {@link /api/v1/products/catalog/brands/}
 */
export async function listBrands(
  params?: ListBrandsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListBrandsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListBrandsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
